import { CourseDetailDto } from '../dtos/course-detail.dto';
import { Course } from '../models/course';
import { CourseDetail } from '../models/course-detail';
import { classRegistrationDetailMapper } from './class-registration-detail.mapper';
import { dateMapper } from './date.mapper';
import { packageMapper } from './package.mapper';
import { trainingCertificateMapper } from './training-certificate.mapper';
import { COURSE_STATUS } from '../models/course-status';

const MAP_STATUS_FROM_DTO = {
  not_started: COURSE_STATUS.NOT_STARTED,
  in_progress: COURSE_STATUS.IN_PROGRESS,
  completed: COURSE_STATUS.COMPLETED,
};

/**
 * Map course detail from dto.
 * @param {CourseDetailDto} dto Dto.
 * @returns {CourseDetail}
 */
function mapDetailFromDto(dto) {
  return new CourseDetail({
    id: dto.id,
    name: dto.name,
    description: dto.description,
    code: dto.code,
    totalQuizzes: dto.total_quizzes,
    ansiApproved: dto.ansi_approved,
    certificateId: dto.certificate_id,
    active: dto.active,
    createdDate: dateMapper.fromDto(dto.create_date),
    editedDate: dateMapper.fromDto(dto.edit_date),
  });
}

/**
 * Map from dto.
 * @param {object} dto Dto.
 * @returns {Course}
 */
function fromDto(dto) {
  return new Course({
    isAllowCertificate: dto.allow_certificate,
    isAllowTransfer: dto.allow_transfer,
    course: mapDetailFromDto(dto.course),
    expiredDate: dateMapper.fromDto(dto.expiration_date),
    certificateExpiredDate: dateMapper.fromDto(dto.certificate_expiration_date),
    isCertificateExpired: dto.is_certificate_expired,
    canPurchaseLaminatedCard: dto.can_purchase_laminated_card,
    isCompleted: dto.is_completed,
    isExpired: dto.is_expired,
    progress: dto.progress,
    purchasedDate: dateMapper.fromDto(dto.purchase_date),
    status: MAP_STATUS_FROM_DTO[dto.status_code],
    isPendingPayment: dto.is_pending_payment,
    registration: dto.registration ? classRegistrationDetailMapper.fromDto(dto.registration) : null,
    trainingCertificate: dto.training_certificate ? trainingCertificateMapper.fromDto(dto.training_certificate) : null,
    package: dto.package ? packageMapper.fromDto(dto.package) : null,
  });
}

export const courseMapper = {
  fromDto,
  mapDetailFromDto,
};
